import { render, staticRenderFns } from "./status-pagamento.vue?vue&type=template&id=6dc53685&scoped=true"
import script from "./status-pagamento.vue?vue&type=script&lang=js"
export * from "./status-pagamento.vue?vue&type=script&lang=js"
import style0 from "./status-pagamento.vue?vue&type=style&index=0&id=6dc53685&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc53685",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loader: require('/home/luiz/Sistemas/loja/components/Loader.vue').default,DialogStatusPayment: require('/home/luiz/Sistemas/loja/components/DialogStatusPayment.vue').default})
